import React, { useState, useEffect } from "react";
import { getResumeGuru, getPhotoUrl } from "../api";
import {
  getHasilSurvey,
  getGuru,
  getSiswa,
  getMasterData,
  addGuru,
  updateGuru,
  addSiswa,
  updateSiswa,
  addPenugasan,
  deleteGuru,
  deleteSiswa,
  deletePenugasan,
  getAllSemester,
  getActiveSemester,
  setActiveSemester,
} from "../api";
import axios from "axios";
import "../styles/Admin.css";
import "../styles/AdminTable.css";
import "../styles/AdminDashboard.css";
import "../styles/SemesterManagement.css";

const API_URL = "https://sipuas.online/api";

function AdminPage({ user }) {
  const [activeTab, setActiveTab] = useState("hasil");
  const [submitMode, setSubmitMode] = useState("final");
  const [hasil, setHasil] = useState([]);
  const [guru, setGuru] = useState([]);
  const [siswa, setSiswa] = useState([]);
  const [kelas, setKelas] = useState([]);
  const [mapel, setMapel] = useState([]);
  const [penugasan, setPenugasan] = useState([]);
  const [unit, setUnit] = useState([]);
  const [semesterList, setSemesterList] = useState([]);
  const [semester, setSemester] = useState("");
  const [openGuruId, setOpenGuruId] = useState(null);
  // 🔽 Expand row hasil survey
  const [openRow, setOpenRow] = useState(null);

  // NEW: Dashboard improvement states
  const [dashboardStats, setDashboardStats] = useState(null);
  const [filteredHasil, setFilteredHasil] = useState([]);
  const [filters, setFilters] = useState({
    search: "",
    unitSekolah: "",
    minScore: "",
    maxScore: "",
    sortBy: "rata_rata_keseluruhan",
    sortOrder: "desc",
  });
  const [viewMode, setViewMode] = useState("table");
  const [selectedGuruResume, setSelectedGuruResume] = useState(null);
  const [resumeList, setResumeList] = useState([]);
  const [showResumeModal, setShowResumeModal] = useState(false);

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({});

  // STATE SEMESTER INI:
  const [semesterData, setSemesterData] = useState([]);
  const [showSemesterModal, setShowSemesterModal] = useState(false);
  const [semesterFormData, setSemesterFormData] = useState({});
  const [editingSemester, setEditingSemester] = useState(null);
  const [showActivateWarning, setShowActivateWarning] = useState(false);
  const [semesterToActivate, setSemesterToActivate] = useState(null);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [copyFromSemester, setCopyFromSemester] = useState("");
  const [copyToSemester, setCopyToSemester] = useState("");

  // Permission checks
  const isSuperAdmin = user.role === "super_admin";
  const isAdminSekolah = user.role === "admin_sekolah";
  const isKepalaSekolah = user.role === "kepala_sekolah";
  const isReadOnly = isKepalaSekolah;
  const userUnitId = user.unit_sekolah_id;

  // Load semester saat mount
  useEffect(() => {
    loadSemesterList();
  }, []);

  // Load data ketika semester berubah
  useEffect(() => {
    if (semester) {
      loadData();
    }
  }, [activeTab, semester]);

  // NEW: Apply filters when hasil or filters change
  useEffect(() => {
    applyFilters();
  }, [hasil, filters]);

  // Load semester data saat tab Semester aktif
  useEffect(() => {
    if (activeTab === "semester") {
      loadSemesterData();
    }
  }, [activeTab]);

  const loadSemesterList = async () => {
    try {
      const res = await getAllSemester();
      if (res.data.success) {
        setSemesterList(res.data.data);

        // Set semester aktif sebagai default
        const activeSem = res.data.data.find((s) => s.is_active === 1);
        if (activeSem) {
          setSemester(activeSem.kode_semester);
        } else if (res.data.data.length > 0) {
          setSemester(res.data.data[0].kode_semester);
        }
      }
    } catch (err) {
      console.error("Error loading semester list:", err);
    }
  };

  const loadData = async () => {
    try {
      if (activeTab === "hasil") {
        const res = await getHasilSurvey(semester);
        if (res.data.success) {
          let data = res.data.data;
          if (!isSuperAdmin && userUnitId) {
            data = data.filter((h) => h.unit_sekolah_id === userUnitId);
          }
          setHasil(data);
          calculateDashboardStats(data);
        }
      } else if (activeTab === "unit") {
        const res = await getMasterData("get_unit_sekolah");
        if (res.data.success) setUnit(res.data.data);
      } else if (activeTab === "kelas") {
        const [kelasRes, unitRes] = await Promise.all([
          getMasterData("get_kelas"),
          getMasterData("get_unit_sekolah"),
        ]);
        if (kelasRes.data.success) {
          let kelasData = kelasRes.data.data;
          if (!isSuperAdmin && userUnitId) {
            kelasData = kelasData.filter(
              (k) => k.unit_sekolah_id === userUnitId
            );
          }
          setKelas(kelasData);
        }
        if (unitRes.data.success) setUnit(unitRes.data.data);
      } else if (activeTab === "mapel") {
        const res = await getMasterData("get_mata_pelajaran");
        if (res.data.success) setMapel(res.data.data);
      } else if (activeTab === "guru") {
        const res = await getGuru();
        if (res.data.success) {
          let guruData = res.data.data;

          // ✅ FIX: Filter guru berdasarkan penugasan di kelas unit ini
          if (!isSuperAdmin && userUnitId) {
            const kelasRes = await getMasterData("get_kelas");
            const penugasanRes = await getMasterData("get_penugasan");

            if (kelasRes.data.success && penugasanRes.data.success) {
              // Ambil ID kelas yang ada di unit ini
              const kelasIdsInUnit = kelasRes.data.data
                .filter((k) => k.unit_sekolah_id === userUnitId)
                .map((k) => k.id);

              // Ambil guru yang mengajar di kelas-kelas tersebut
              const guruIdsInUnit = [
                ...new Set(
                  penugasanRes.data.data
                    .filter((p) => kelasIdsInUnit.includes(p.kelas_id))
                    .map((p) => p.guru_id)
                ),
              ];

              guruData = guruData.filter((g) => guruIdsInUnit.includes(g.id));
            }
          }

          setGuru(guruData);
        }
      } else if (activeTab === "siswa") {
        const [siswaRes, kelasRes] = await Promise.all([
          getSiswa(),
          getMasterData("get_kelas"),
        ]);
        if (siswaRes.data.success) {
          let siswaData = siswaRes.data.data;

          // ✅ FIX: Filter siswa berdasarkan kelas.unit_sekolah_id
          if (!isSuperAdmin && userUnitId) {
            // Ambil ID kelas yang ada di unit ini
            const kelasIdsInUnit = kelasRes.data.data
              .filter((k) => k.unit_sekolah_id === userUnitId)
              .map((k) => k.id);

            // Filter siswa yang ada di kelas-kelas tersebut
            siswaData = siswaData.filter((s) =>
              kelasIdsInUnit.includes(s.kelas_id)
            );
          }

          setSiswa(siswaData);
        }
        if (kelasRes.data.success) {
          let kelasData = kelasRes.data.data;
          if (!isSuperAdmin && userUnitId) {
            kelasData = kelasData.filter(
              (k) => k.unit_sekolah_id === userUnitId
            );
          }
          setKelas(kelasData);
        }
      } else if (activeTab === "penugasan") {
        const [guruRes, kelasRes, mapelRes, tugasRes] = await Promise.all([
          getGuru(),
          getMasterData("get_kelas"),
          getMasterData("get_mata_pelajaran"),
          getMasterData("get_penugasan"),
        ]);
        if (guruRes.data.success) setGuru(guruRes.data.data);
        if (kelasRes.data.success) {
          let kelasData = kelasRes.data.data;
          if (!isSuperAdmin && userUnitId) {
            kelasData = kelasData.filter(
              (k) => k.unit_sekolah_id === userUnitId
            );
          }
          setKelas(kelasData);
        }
        if (mapelRes.data.success) setMapel(mapelRes.data.data);
        if (tugasRes.data.success) {
          let tugasData = tugasRes.data.data;

          // ✅ FIX: Filter penugasan berdasarkan kelas.unit_sekolah_id
          if (!isSuperAdmin && userUnitId) {
            // Ambil ID kelas yang ada di unit ini
            const kelasIdsInUnit = kelasRes.data.data
              .filter((k) => k.unit_sekolah_id === userUnitId)
              .map((k) => k.id);

            // Filter penugasan yang ada di kelas-kelas tersebut
            tugasData = tugasData.filter((t) =>
              kelasIdsInUnit.includes(t.kelas_id)
            );
          }

          setPenugasan(tugasData);
        } else if (activeTab === "semester") {
          loadSemesterData();
        }
      }
    } catch (err) {
      alert("Gagal memuat data");
    }
  };

  // ========== NEW FUNCTIONS FOR DASHBOARD ==========

  const calculateDashboardStats = (data) => {
    if (data.length === 0) {
      setDashboardStats(null);
      return;
    }

    const totalGuru = data.length;
    const totalResponden = data.reduce(
      (sum, h) => sum + parseInt(h.jumlah_responden),
      0
    );
    const avgSekolah = (
      data.reduce((sum, h) => sum + parseFloat(h.rata_rata_keseluruhan), 0) /
      totalGuru
    ).toFixed(2);

    const distribusi = {
      sangatMemuaskan: data.filter(
        (h) => parseFloat(h.rata_rata_keseluruhan) >= 4.5
      ).length,
      memuaskan: data.filter(
        (h) =>
          parseFloat(h.rata_rata_keseluruhan) >= 3.5 &&
          parseFloat(h.rata_rata_keseluruhan) < 4.5
      ).length,
      cukup: data.filter(
        (h) =>
          parseFloat(h.rata_rata_keseluruhan) >= 2.5 &&
          parseFloat(h.rata_rata_keseluruhan) < 3.5
      ).length,
      kurang: data.filter(
        (h) =>
          parseFloat(h.rata_rata_keseluruhan) >= 1.5 &&
          parseFloat(h.rata_rata_keseluruhan) < 2.5
      ).length,
      tidakMemuaskan: data.filter(
        (h) => parseFloat(h.rata_rata_keseluruhan) < 1.5
      ).length,
    };

    const aspekAvg = {
      aspek_1: (
        data.reduce((sum, h) => sum + parseFloat(h.aspek_1 || 0), 0) / totalGuru
      ).toFixed(2),
      aspek_2: (
        data.reduce((sum, h) => sum + parseFloat(h.aspek_2 || 0), 0) / totalGuru
      ).toFixed(2),
      aspek_3: (
        data.reduce((sum, h) => sum + parseFloat(h.aspek_3 || 0), 0) / totalGuru
      ).toFixed(2),
      aspek_4: (
        data.reduce((sum, h) => sum + parseFloat(h.aspek_4 || 0), 0) / totalGuru
      ).toFixed(2),
      aspek_5: (
        data.reduce((sum, h) => sum + parseFloat(h.aspek_5 || 0), 0) / totalGuru
      ).toFixed(2),
    };

    const aspekLabels = {
      aspek_1: "Penguasaan Materi",
      aspek_2: "Metode Pembelajaran",
      aspek_3: "Kedisiplinan",
      aspek_4: "Komunikasi",
      aspek_5: "Motivasi & Inspirasi",
    };

    const aspekSorted = Object.entries(aspekAvg)
      .map(([key, value]) => ({
        key,
        label: aspekLabels[key],
        value: parseFloat(value),
      }))
      .sort((a, b) => b.value - a.value);

    const topAspek = aspekSorted[0];
    const bottomAspek = aspekSorted[aspekSorted.length - 1];

    setDashboardStats({
      totalGuru,
      totalResponden,
      avgSekolah,
      distribusi,
      aspekAvg,
      topAspek,
      bottomAspek,
    });
  };

  const applyFilters = () => {
    let filtered = [...hasil];

    if (filters.search) {
      filtered = filtered.filter(
        (h) =>
          h.nama_guru.toLowerCase().includes(filters.search.toLowerCase()) ||
          h.nip.includes(filters.search)
      );
    }

    if (filters.unitSekolah) {
      filtered = filtered.filter(
        (h) => h.unit_sekolah_id == filters.unitSekolah
      );
    }

    if (filters.minScore) {
      filtered = filtered.filter(
        (h) =>
          parseFloat(h.rata_rata_keseluruhan) >= parseFloat(filters.minScore)
      );
    }
    if (filters.maxScore) {
      filtered = filtered.filter(
        (h) =>
          parseFloat(h.rata_rata_keseluruhan) <= parseFloat(filters.maxScore)
      );
    }

    filtered.sort((a, b) => {
      let aVal, bVal;

      if (filters.sortBy === "nama_guru") {
        aVal = a.nama_guru;
        bVal = b.nama_guru;
        return filters.sortOrder === "asc"
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      } else if (filters.sortBy === "jumlah_responden") {
        aVal = parseInt(a.jumlah_responden);
        bVal = parseInt(b.jumlah_responden);
      } else {
        aVal = parseFloat(a.rata_rata_keseluruhan);
        bVal = parseFloat(b.rata_rata_keseluruhan);
      }

      return filters.sortOrder === "asc" ? aVal - bVal : bVal - aVal;
    });

    setFilteredHasil(filtered);
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const resetFilters = () => {
    setFilters({
      search: "",
      unitSekolah: "",
      minScore: "",
      maxScore: "",
      sortBy: "rata_rata_keseluruhan",
      sortOrder: "desc",
    });
  };

  const loadResumeGuru = async (guruId, guruNama) => {
    try {
      const response = await axios.get(
        `${API_URL}/get_resume_guru.php?guru_id=${guruId}&semester=${semester}`
      );

      if (response.data.success) {
        if (response.data.data.length === 0) {
          alert(`Belum ada resume dari siswa untuk ${guruNama}`);
          return;
        }
        setResumeList(response.data.data);
        setSelectedGuruResume({ id: guruId, nama: guruNama });
        setShowResumeModal(true);
      } else {
        alert("Terjadi kesalahan saat memuat resume");
      }
    } catch (err) {
      console.error("Error loading resume:", err);
      alert("Gagal memuat resume siswa. Periksa koneksi atau backend.");
    }
  };

  const handleExportExcel = () => {
    const headers = [
      "No",
      "Nama Guru",
      "NUPTK",
      "Responden",
      "Rata-rata",
      "Penguasaan Materi",
      "Metode Pembelajaran",
      "Kedisiplinan",
      "Komunikasi",
      "Motivasi & Inspirasi",
      "Kategori",
    ];

    const rows = filteredHasil.map((h, idx) => [
      idx + 1,
      h.nama_guru,
      h.nip,
      h.jumlah_responden,
      h.rata_rata_keseluruhan,
      h.aspek_1,
      h.aspek_2,
      h.aspek_3,
      h.aspek_4,
      h.aspek_5,
      getScoreLabel(h.rata_rata_keseluruhan).label,
    ]);

    const csvContent = [headers, ...rows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", `Hasil_Survey_${semester}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openModal = (type, data = null) => {
    if (isReadOnly) {
      alert("Anda tidak memiliki akses untuk mengubah data");
      return;
    }

    setModalType(type);
    setEditMode(!!data);

    if (type === "unit") {
      setFormData(data || { nama_unit: "", jenjang: "SMP" });
    } else if (type === "kelas") {
      setFormData(
        data || {
          nama_kelas: "",
          unit_sekolah_id: userUnitId || "",
          tingkat: "",
        }
      );
    } else if (type === "mapel") {
      setFormData(data || { nama_mapel: "" });
    } else if (type === "guru") {
      setFormData(
        data || { nip: "", nama_lengkap: "", username: "", password: "" }
      );
    } else if (type === "siswa") {
      setFormData(
        data || {
          nis: "",
          nama_lengkap: "",
          kelas_id: "",
          username: "",
          password: "",
        }
      );
    } else if (type === "penugasan") {
      setFormData(
        data || {
          guru_id: "",
          kelas_id: "",
          mata_pelajaran_id: "",
          semester: semester,
        }
      );
    }

    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setFormData({});
    setEditMode(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      isAdminSekolah &&
      (modalType === "kelas" ||
        modalType === "siswa" ||
        modalType === "penugasan")
    ) {
      if (modalType === "kelas" && formData.unit_sekolah_id != userUnitId) {
        alert("Anda hanya bisa mengelola kelas di unit sekolah Anda");
        return;
      }
    }

    try {
      if (modalType === "unit") {
        if (editMode) {
          await axios.put(`${API_URL}/data.php?action=update_unit`, formData);
        } else {
          await axios.post(`${API_URL}/data.php?action=add_unit`, formData);
        }
      } else if (modalType === "kelas") {
        if (isAdminSekolah) {
          formData.unit_sekolah_id = userUnitId;
        }
        if (editMode) {
          await axios.put(`${API_URL}/data.php?action=update_kelas`, formData);
        } else {
          await axios.post(`${API_URL}/data.php?action=add_kelas`, formData);
        }
      } else if (modalType === "mapel") {
        if (editMode) {
          await axios.put(`${API_URL}/data.php?action=update_mapel`, formData);
        } else {
          await axios.post(`${API_URL}/data.php?action=add_mapel`, formData);
        }
      } else if (modalType === "guru") {
        if (editMode) {
          await updateGuru(formData);
        } else {
          await addGuru(formData);
        }
      } else if (modalType === "siswa") {
        if (editMode) {
          await updateSiswa(formData);
        } else {
          await addSiswa(formData);
        }
      } else if (modalType === "penugasan") {
        await addPenugasan(formData);
      }

      alert(editMode ? "Data berhasil diupdate" : "Data berhasil ditambahkan");
      closeModal();
      loadData();
    } catch (err) {
      alert("Gagal menyimpan data");
    }
  };

  const handleDelete = async (type, id) => {
    if (isReadOnly) {
      alert("Anda tidak memiliki akses untuk menghapus data");
      return;
    }

    if (!window.confirm("Yakin hapus data ini?")) return;

    try {
      if (type === "unit") {
        await axios.post(`${API_URL}/data.php?action=delete_unit`, {
          id,
        });
      } else if (type === "kelas") {
        await axios.post(`${API_URL}/data.php?action=delete_kelas`, {
          id,
        });
      } else if (type === "mapel") {
        await axios.post(`${API_URL}/data.php?action=delete_mapel`, {
          id,
        });
      } else if (type === "guru") {
        await deleteGuru(id);
      } else if (type === "siswa") {
        await deleteSiswa(id);
      } else if (type === "penugasan") {
        await deletePenugasan(id);
      }

      alert("Data berhasil dihapus");
      loadData();
    } catch (err) {
      alert("Gagal menghapus data");
    }
  };

  const handleUploadFoto = async (guru_id, file) => {
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      alert("Format file harus JPG atau PNG");
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      alert("Ukuran file maksimal 2MB");
      return;
    }

    const formData = new FormData();
    formData.append("foto", file);
    formData.append("guru_id", guru_id);

    try {
      const response = await axios.post(
        `${API_URL}/upload_foto.php`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        alert("Foto berhasil diupload");
        loadData();
      } else {
        alert("Gagal upload foto: " + response.data.message);
      }
    } catch (err) {
      alert("Error upload foto");
    }
  };

  const handleDeleteFoto = async (guru_id) => {
    if (!window.confirm("Yakin hapus foto guru ini?")) return;

    try {
      const response = await axios.post(`${API_URL}/delete_foto.php`, {
        guru_id: guru_id,
      });

      if (response.data.success) {
        alert("Foto berhasil dihapus");
        loadData();
      } else {
        alert("Gagal hapus foto");
      }
    } catch (err) {
      alert("Error hapus foto");
    }
  };

  // ========== SEMESTER MANAGEMENT FUNCTIONS ==========

  const loadSemesterData = async () => {
    try {
      const response = await axios.get(`${API_URL}/manage.php?action=get_all`);
      if (response.data.success) {
        setSemesterData(response.data.data);
      }
    } catch (err) {
      console.error("Error loading semester:", err);
      alert("Gagal memuat data semester");
    }
  };

  const openSemesterModal = (semester = null) => {
    if (semester) {
      setEditingSemester(semester);
      setSemesterFormData({
        id: semester.id,
        kode_semester: semester.kode_semester,
        nama_semester: semester.nama_semester,
        tahun_ajaran: semester.tahun_ajaran,
        tanggal_mulai: semester.tanggal_mulai,
        tanggal_selesai: semester.tanggal_selesai,
      });
    } else {
      setEditingSemester(null);
      setSemesterFormData({
        kode_semester: "",
        nama_semester: "",
        tahun_ajaran: "",
        tanggal_mulai: "",
        tanggal_selesai: "",
        is_aktif: false,
      });
    }
    setShowSemesterModal(true);
  };

  const closeSemesterModal = () => {
    setShowSemesterModal(false);
    setEditingSemester(null);
    setSemesterFormData({});
  };

  const handleSemesterSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editingSemester) {
        // Update semester
        const response = await axios.put(
          `${API_URL}/manage.php?action=update`,
          semesterFormData
        );

        if (response.data.success) {
          alert("Semester berhasil diupdate");
          closeSemesterModal();
          loadSemesterData();
        } else {
          alert(response.data.message || "Gagal mengupdate semester");
        }
      } else {
        // Add new semester
        const response = await axios.post(
          `${API_URL}/manage.php?action=add`,
          semesterFormData
        );

        if (response.data.success) {
          alert("Semester berhasil ditambahkan");
          closeSemesterModal();
          loadSemesterData();
          loadSemesterList(); // Refresh semester list di dropdown
        } else {
          alert(response.data.message || "Gagal menambahkan semester");
        }
      }
    } catch (err) {
      console.error("Error:", err);
      alert("Terjadi kesalahan saat menyimpan semester");
    }
  };

  const handleActivateSemester = (semester) => {
    setSemesterToActivate(semester);
    setShowActivateWarning(true);
  };

  const confirmActivateSemester = async () => {
    if (!semesterToActivate) return;

    try {
      const response = await axios.post(
        `${API_URL}/manage.php?action=set_active`,
        { id: semesterToActivate.id }
      );

      if (response.data.success) {
        alert("Semester berhasil diaktifkan");
        setShowActivateWarning(false);
        setSemesterToActivate(null);
        loadSemesterData();
        loadSemesterList(); // Refresh semester list
      } else {
        alert(response.data.message || "Gagal mengaktifkan semester");
      }
    } catch (err) {
      console.error("Error:", err);
      alert("Terjadi kesalahan saat mengaktifkan semester");
    }
  };

  const handleDeleteSemester = async (semester) => {
    if (
      !window.confirm(
        `Yakin ingin menghapus semester "${semester.kode_semester}"?`
      )
    ) {
      return;
    }

    try {
      const response = await axios.delete(
        `${API_URL}/manage.php?action=delete`,
        { data: { id: semester.id } }
      );

      if (response.data.success) {
        alert("Semester berhasil dihapus");
        loadSemesterData();
        loadSemesterList(); // Refresh semester list
      } else {
        alert(response.data.message || "Gagal menghapus semester");
      }
    } catch (err) {
      console.error("Error:", err);
      if (err.response && err.response.data) {
        alert(
          err.response.data.message ||
            "Terjadi kesalahan saat menghapus semester"
        );
      } else {
        alert("Terjadi kesalahan saat menghapus semester");
      }
    }
  };

  const openCopyPenugasanModal = () => {
    setCopyFromSemester("");
    setCopyToSemester("");
    setShowCopyModal(true);
  };

  const handleCopyPenugasan = async () => {
    if (!copyFromSemester || !copyToSemester) {
      alert("Pilih semester asal dan tujuan");
      return;
    }

    if (copyFromSemester === copyToSemester) {
      alert("Semester asal dan tujuan tidak boleh sama");
      return;
    }

    try {
      const response = await axios.post(
        `${API_URL}/manage.php?action=copy_penugasan`,
        {
          from_semester_id: copyFromSemester,
          to_semester_id: copyToSemester,
        }
      );

      if (response.data.needs_confirmation) {
        // Target semester sudah ada penugasan, minta konfirmasi
        if (window.confirm(response.data.message)) {
          // Retry with confirmation
          const retryResponse = await axios.post(
            `${API_URL}/manage.php?action=copy_penugasan`,
            {
              from_semester_id: copyFromSemester,
              to_semester_id: copyToSemester,
              confirm: true,
            }
          );

          if (retryResponse.data.success) {
            alert(retryResponse.data.message);
            setShowCopyModal(false);
            setCopyFromSemester("");
            setCopyToSemester("");
          } else {
            alert(retryResponse.data.message || "Gagal menyalin penugasan");
          }
        }
      } else if (response.data.success) {
        alert(response.data.message);
        setShowCopyModal(false);
        setCopyFromSemester("");
        setCopyToSemester("");
      } else {
        alert(response.data.message || "Gagal menyalin penugasan");
      }
    } catch (err) {
      console.error("Error:", err);
      alert("Terjadi kesalahan saat menyalin penugasan");
    }
  };

  const getScoreLabel = (score) => {
    const s = parseFloat(score);
    if (s >= 4.5) return { label: "Sangat Memuaskan", color: "#22c55e" };
    if (s >= 3.5) return { label: "Memuaskan", color: "#3b82f6" };
    if (s >= 2.5) return { label: "Cukup Memuaskan", color: "#eab308" };
    if (s >= 1.5) return { label: "Kurang Memuaskan", color: "#f97316" };
    return { label: "Tidak Memuaskan", color: "#ef4444" };
  };

  const getScoreColor = (value) => {
    const v = parseFloat(value);
    if (v < 2.5) return "#ef4444"; // merah
    if (v < 3.5) return "#eab308"; // kuning
    return "#22c55e"; // hijau
  };

  const showUnitTab = isSuperAdmin;
  const showKelasTab = true;
  const showMapelTab = true;
  const showGuruTab = true;
  const showSiswaTab = true;
  const showPenugasanTab = true;
  // ===============================
  // GROUP PENUGASAN PER GURU (FINAL)
  // ===============================
  const groupedPenugasan = Object.values(
    penugasan.reduce((acc, p) => {
      if (!acc[p.guru_id]) {
        acc[p.guru_id] = {
          guru_id: p.guru_id,
          nama_guru: p.nama_guru,
          semester: p.semester,
          detail: [],
        };
      }

      acc[p.guru_id].detail.push({
        id: p.id,
        nama_mapel: p.nama_mapel,
        nama_kelas: p.nama_kelas,
      });

      return acc;
    }, {})
  );

  // SORT DATA HASIL SURVEY
  const sortedHasil = [...hasil].sort(
    (a, b) => b.rata_rata_keseluruhan - a.rata_rata_keseluruhan
  );

  return (
    <div className="admin-page">
      <div className="admin-header">
        <div>
          <h1>
            {isSuperAdmin && "Super Admin Dashboard"}
            {isAdminSekolah && `Admin Dashboard - ${user.nama_lengkap}`}
            {isKepalaSekolah && `Kepala Sekolah - ${user.nama_lengkap}`}
          </h1>
          {isReadOnly && (
            <p className="read-only-notice">Mode: Hanya Lihat (Read-Only)</p>
          )}
        </div>
        <div className="tabs">
          <button
            className={activeTab === "hasil" ? "active" : ""}
            onClick={() => setActiveTab("hasil")}
          >
            Hasil Survey
          </button>
          {showUnitTab && (
            <button
              className={activeTab === "unit" ? "active" : ""}
              onClick={() => setActiveTab("unit")}
            >
              Unit Sekolah
            </button>
          )}
          {showKelasTab && (
            <button
              className={activeTab === "kelas" ? "active" : ""}
              onClick={() => setActiveTab("kelas")}
            >
              Kelas
            </button>
          )}
          {showMapelTab && (
            <button
              className={activeTab === "mapel" ? "active" : ""}
              onClick={() => setActiveTab("mapel")}
            >
              Mata Pelajaran
            </button>
          )}
          {showGuruTab && (
            <button
              className={activeTab === "guru" ? "active" : ""}
              onClick={() => setActiveTab("guru")}
            >
              Guru
            </button>
          )}
          {showSiswaTab && (
            <button
              className={activeTab === "siswa" ? "active" : ""}
              onClick={() => setActiveTab("siswa")}
            >
              Siswa
            </button>
          )}
          {showPenugasanTab && (
            <button
              className={activeTab === "penugasan" ? "active" : ""}
              onClick={() => setActiveTab("penugasan")}
            >
              Penugasan
            </button>
          )}
          {/* TAB SEMESTER - KHUSUS SUPER ADMIN */}
          {isSuperAdmin && (
            <button
              className={activeTab === "semester" ? "active" : ""}
              onClick={() => setActiveTab("semester")}
            >
              📅 Semester
            </button>
          )}
        </div>
      </div>

      <div className="admin-content">
        {/* ============================================ */}
        {/* TAB HASIL SURVEY - IMPROVED VERSION */}
        {/* ============================================ */}
        {activeTab === "hasil" && (
          <div className="hasil-survey-section">
            {/* Header dengan Semester selector */}
            <div className="section-header-new">
              <div className="header-left">
                <h1>📊 Hasil Survey Kepuasan Siswa</h1>
                <p className="subtitle">
                  Analisis komprehensif performa guru semester {semester}
                </p>
              </div>
              <div className="header-right">
                <select
                  value={semester}
                  onChange={(e) => setSemester(e.target.value)}
                  className="semester-select-new"
                >
                  <option value="">-- Pilih Semester --</option>
                  {semesterList.map((s) => (
                    <option key={s.id} value={s.kode_semester}>
                      {s.kode_semester} {s.is_active === 1 ? "✓ (Aktif)" : ""}
                    </option>
                  ))}
                </select>
                <button
                  className="btn-export-new"
                  onClick={handleExportExcel}
                  disabled={filteredHasil.length === 0}
                >
                  📥 Export Excel
                </button>
              </div>
            </div>

            {/* Dashboard Statistics Cards - 5 DALAM 1 BARIS */}
            {dashboardStats && (
              <div className="dashboard-stats">
                <div className="stat-card primary">
                  <div className="stat-icon">🎯</div>
                  <div className="stat-content">
                    <h3>{dashboardStats.avgSekolah}</h3>
                    <p>Rata-rata Sekolah</p>
                    <span className="stat-label">
                      {getScoreLabel(dashboardStats.avgSekolah).label}
                    </span>
                  </div>
                </div>

                <div className="stat-card">
                  <div className="stat-icon">👥</div>
                  <div className="stat-content">
                    <h3>{dashboardStats.totalGuru}</h3>
                    <p>Total Guru Dinilai</p>
                  </div>
                </div>

                <div className="stat-card">
                  <div className="stat-icon">📝</div>
                  <div className="stat-content">
                    <h3>{dashboardStats.totalResponden}</h3>
                    <p>Total Responden</p>
                  </div>
                </div>

                <div className="stat-card success">
                  <div className="stat-icon">⭐</div>
                  <div className="stat-content">
                    <h3>{dashboardStats.topAspek.value}</h3>
                    <p>Aspek Terbaik</p>
                    <span className="stat-label">
                      {dashboardStats.topAspek.label}
                    </span>
                  </div>
                </div>

                <div className="stat-card warning">
                  <div className="stat-icon">📈</div>
                  <div className="stat-content">
                    <h3>{dashboardStats.bottomAspek.value}</h3>
                    <p>Perlu Ditingkatkan</p>
                    <span className="stat-label">
                      {dashboardStats.bottomAspek.label}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* Distribution Chart */}
            {dashboardStats && (
              <div className="distribution-section">
                <h3>📊 Distribusi Kategori Performa</h3>
                <div className="distribution-bars">
                  {[
                    {
                      label: "Sangat Memuaskan",
                      count: dashboardStats.distribusi.sangatMemuaskan,
                      color: "#22c55e",
                    },
                    {
                      label: "Memuaskan",
                      count: dashboardStats.distribusi.memuaskan,
                      color: "#3b82f6",
                    },
                    {
                      label: "Cukup Memuaskan",
                      count: dashboardStats.distribusi.cukup,
                      color: "#eab308",
                    },
                    {
                      label: "Kurang Memuaskan",
                      count: dashboardStats.distribusi.kurang,
                      color: "#f97316",
                    },
                    {
                      label: "Tidak Memuaskan",
                      count: dashboardStats.distribusi.tidakMemuaskan,
                      color: "#ef4444",
                    },
                  ].map((item, idx) => {
                    const percentage =
                      dashboardStats.totalGuru > 0
                        ? (
                            (item.count / dashboardStats.totalGuru) *
                            100
                          ).toFixed(1)
                        : 0;
                    return (
                      <div key={idx} className="distribution-item">
                        <div className="dist-label">
                          <span>{item.label}</span>
                          <span className="dist-count">
                            {item.count} guru ({percentage}%)
                          </span>
                        </div>
                        <div className="dist-bar-container">
                          <div
                            className="dist-bar-fill"
                            style={{
                              width: `${percentage}%`,
                              backgroundColor: item.color,
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Advanced Filters */}
            <div className="advanced-filters">
              <div className="filter-header">
                <h3>🔍 Filter & Pencarian</h3>
                <button className="btn-reset-filter" onClick={resetFilters}>
                  🔄 Reset Filter
                </button>
              </div>

              <div className="filter-grid">
                <div className="filter-item">
                  <label>Cari Nama/NUPTK</label>
                  <input
                    type="text"
                    placeholder="Ketik nama guru atau NUPTK..."
                    value={filters.search}
                    onChange={(e) =>
                      handleFilterChange("search", e.target.value)
                    }
                    className="filter-input"
                  />
                </div>

                {isSuperAdmin && (
                  <div className="filter-item">
                    <label>Unit Sekolah</label>
                    <select
                      value={filters.unitSekolah}
                      onChange={(e) =>
                        handleFilterChange("unitSekolah", e.target.value)
                      }
                      className="filter-select"
                    >
                      <option value="">Semua Unit</option>
                      {unit.map((u) => (
                        <option key={u.id} value={u.id}>
                          {u.nama_unit}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="filter-item">
                  <label>Skor Minimal</label>
                  <input
                    type="number"
                    min="0"
                    max="5"
                    step="0.1"
                    placeholder="0.0"
                    value={filters.minScore}
                    onChange={(e) =>
                      handleFilterChange("minScore", e.target.value)
                    }
                    className="filter-input"
                  />
                </div>

                <div className="filter-item">
                  <label>Skor Maksimal</label>
                  <input
                    type="number"
                    min="0"
                    max="5"
                    step="0.1"
                    placeholder="5.0"
                    value={filters.maxScore}
                    onChange={(e) =>
                      handleFilterChange("maxScore", e.target.value)
                    }
                    className="filter-input"
                  />
                </div>

                <div className="filter-item">
                  <label>Urutkan Berdasarkan</label>
                  <select
                    value={filters.sortBy}
                    onChange={(e) =>
                      handleFilterChange("sortBy", e.target.value)
                    }
                    className="filter-select"
                  >
                    <option value="rata_rata_keseluruhan">Rata-rata</option>
                    <option value="nama_guru">Nama Guru</option>
                    <option value="jumlah_responden">Jumlah Responden</option>
                  </select>
                </div>

                <div className="filter-item">
                  <label>Urutan</label>
                  <select
                    value={filters.sortOrder}
                    onChange={(e) =>
                      handleFilterChange("sortOrder", e.target.value)
                    }
                    className="filter-select"
                  >
                    <option value="desc">Tertinggi ke Terendah</option>
                    <option value="asc">Terendah ke Tertinggi</option>
                  </select>
                </div>
              </div>

              <div className="filter-results">
                <span>
                  Menampilkan <strong>{filteredHasil.length}</strong> dari{" "}
                  <strong>{hasil.length}</strong> guru
                </span>
              </div>
            </div>

            {/* View Mode Toggle */}
            <div className="view-mode-toggle">
              <button
                className={viewMode === "table" ? "active" : ""}
                onClick={() => setViewMode("table")}
              >
                📋 Tabel
              </button>
              <button
                className={viewMode === "cards" ? "active" : ""}
                onClick={() => setViewMode("cards")}
              >
                🎴 Kartu
              </button>
            </div>

            {/* Results Display */}
            {filteredHasil.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">🔍</div>
                <h3>Tidak Ada Data</h3>
                <p>
                  {hasil.length === 0
                    ? `Belum ada hasil survey untuk semester ${semester}`
                    : "Tidak ada guru yang cocok dengan filter yang dipilih"}
                </p>
              </div>
            ) : viewMode === "table" ? (
              <div className="results-table-container">
                <table className="hasil-table-new">
                  <thead>
                    <tr>
                      <th className="rank-col">#</th>
                      <th className="foto-col">Foto</th>
                      <th className="nama-col">Nama Guru</th>
                      <th className="nip-col">NUPTK</th>
                      <th className="resp-col">Responden</th>
                      <th className="score-col">Skor Visual</th>
                      <th className="avg-col">Rata-rata</th>
                      <th className="kategori-col">Kategori</th>
                      <th className="action-col">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredHasil.map((h, idx) => {
                      const scoreInfo = getScoreLabel(h.rata_rata_keseluruhan);
                      const isOpen = openRow === h.guru_id;

                      return (
                        <React.Fragment key={h.guru_id}>
                          <tr className={idx < 3 ? "top-performer" : ""}>
                            <td className="rank-cell">
                              <div className="rank-number">
                                {idx + 1}
                                {idx === 0 && (
                                  <span className="trophy">🥇</span>
                                )}
                                {idx === 1 && (
                                  <span className="trophy">🥈</span>
                                )}
                                {idx === 2 && (
                                  <span className="trophy">🥉</span>
                                )}
                              </div>
                            </td>

                            <td className="foto-cell">
                              {h.foto_url ? (
                                <img
                                  src={h.foto_url}
                                  alt={h.nama_guru}
                                  className="guru-avatar"
                                />
                              ) : (
                                <div className="guru-avatar-placeholder">
                                  {h.nama_guru.charAt(0)}
                                </div>
                              )}
                            </td>

                            <td className="nama-cell">
                              <div className="guru-name-cell">
                                <strong>{h.nama_guru}</strong>
                                {h.nama_unit && (
                                  <span className="unit-badge">
                                    {h.nama_unit}
                                  </span>
                                )}
                              </div>
                            </td>

                            <td className="nip-cell">
                              <code>{h.nip}</code>
                            </td>

                            <td className="resp-cell">
                              <span className="responden-badge-new">
                                👥 {h.jumlah_responden}
                              </span>
                            </td>

                            <td className="score-cell">
                              <div className="score-bar-wrapper-new">
                                <div
                                  className="score-bar-fill-new"
                                  style={{
                                    width: `${
                                      (h.rata_rata_keseluruhan / 5) * 100
                                    }%`,
                                    backgroundColor: getScoreColor(
                                      h.rata_rata_keseluruhan
                                    ),
                                  }}
                                >
                                  <span className="score-text">
                                    {(
                                      (h.rata_rata_keseluruhan / 5) *
                                      100
                                    ).toFixed(0)}
                                    %
                                  </span>
                                </div>
                              </div>
                            </td>

                            <td className="avg-cell">
                              <div
                                className="avg-score"
                                style={{
                                  color: getScoreColor(h.rata_rata_keseluruhan),
                                }}
                              >
                                <strong>{h.rata_rata_keseluruhan}</strong>
                                <span className="max-score">/5.0</span>
                              </div>
                            </td>

                            <td className="kategori-cell">
                              <span
                                className="kategori-badge-new"
                                style={{
                                  backgroundColor: getScoreColor(
                                    h.rata_rata_keseluruhan
                                  ),
                                }}
                              >
                                {scoreInfo.emoji} {scoreInfo.label}
                              </span>
                            </td>

                            <td className="action-cell">
                              <div className="action-buttons">
                                <button
                                  className="btn-detail"
                                  onClick={() =>
                                    setOpenRow(isOpen ? null : h.guru_id)
                                  }
                                  title="Lihat Detail Aspek"
                                >
                                  {isOpen ? "▲" : "▼"}
                                </button>
                                <button
                                  className="btn-resume"
                                  onClick={() =>
                                    loadResumeGuru(h.guru_id, h.nama_guru)
                                  }
                                  title="Lihat Resume Siswa"
                                >
                                  💬
                                </button>
                              </div>
                            </td>
                          </tr>

                          {isOpen && (
                            <tr className="detail-row">
                              <td colSpan="9">
                                <div className="aspek-detail-container">
                                  <h4>📊 Breakdown 5 Aspek Penilaian</h4>
                                  <div className="aspek-grid">
                                    {[
                                      {
                                        label: "📖 Penguasaan Materi",
                                        value: h.aspek_1,
                                        key: "aspek_1",
                                      },
                                      {
                                        label: "🎓 Metode Pembelajaran",
                                        value: h.aspek_2,
                                        key: "aspek_2",
                                      },
                                      {
                                        label: "⏰ Kedisiplinan",
                                        value: h.aspek_3,
                                        key: "aspek_3",
                                      },
                                      {
                                        label: "💬 Komunikasi",
                                        value: h.aspek_4,
                                        key: "aspek_4",
                                      },
                                      {
                                        label: "⭐ Motivasi & Inspirasi",
                                        value: h.aspek_5,
                                        key: "aspek_5",
                                      },
                                    ].map((aspek, i) => {
                                      const aspekValue = parseFloat(
                                        aspek.value || 0
                                      );
                                      const percentage = (aspekValue / 5) * 100;
                                      const avgSekolahAspek = dashboardStats
                                        ? parseFloat(
                                            dashboardStats.aspekAvg[aspek.key]
                                          )
                                        : 0;
                                      const comparison =
                                        aspekValue - avgSekolahAspek;

                                      return (
                                        <div key={i} className="aspek-card">
                                          <div className="aspek-header">
                                            <span className="aspek-label">
                                              {aspek.label}
                                            </span>
                                            <span
                                              className="aspek-value"
                                              style={{
                                                color:
                                                  getScoreColor(aspekValue),
                                              }}
                                            >
                                              {aspekValue.toFixed(2)}
                                            </span>
                                          </div>
                                          <div className="aspek-bar">
                                            <div
                                              className="aspek-bar-fill"
                                              style={{
                                                width: `${percentage}%`,
                                                backgroundColor:
                                                  getScoreColor(aspekValue),
                                              }}
                                            />
                                          </div>
                                          {dashboardStats && (
                                            <div className="aspek-comparison">
                                              <span className="comparison-label">
                                                vs Rata-rata Sekolah:
                                              </span>
                                              <span
                                                className={`comparison-value ${
                                                  comparison >= 0
                                                    ? "positive"
                                                    : "negative"
                                                }`}
                                              >
                                                {comparison >= 0 ? "+" : ""}
                                                {comparison.toFixed(2)}
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="results-cards-container">
                {filteredHasil.map((h, idx) => {
                  const scoreInfo = getScoreLabel(h.rata_rata_keseluruhan);

                  return (
                    <div key={h.guru_id} className="guru-result-card">
                      {idx < 3 && (
                        <div className="card-badge">
                          {idx === 0 && "🥇"}
                          {idx === 1 && "🥈"}
                          {idx === 2 && "🥉"}
                        </div>
                      )}

                      <div className="card-header">
                        <div className="card-foto">
                          {h.foto_url ? (
                            <img src={h.foto_url} alt={h.nama_guru} />
                          ) : (
                            <div className="card-foto-placeholder">
                              {h.nama_guru.charAt(0)}
                            </div>
                          )}
                        </div>
                        <div className="card-info">
                          <h3>{h.nama_guru}</h3>
                          <p className="card-nip">{h.nip}</p>
                          {h.nama_unit && (
                            <span className="card-unit">{h.nama_unit}</span>
                          )}
                        </div>
                      </div>

                      <div className="card-score">
                        <div className="main-score">
                          <span className="score-number">
                            {h.rata_rata_keseluruhan}
                          </span>
                          <span className="score-max">/5.0</span>
                        </div>
                        <div
                          className="score-badge"
                          style={{
                            backgroundColor: getScoreColor(
                              h.rata_rata_keseluruhan
                            ),
                          }}
                        >
                          {scoreInfo.emoji} {scoreInfo.label}
                        </div>
                      </div>

                      <div className="card-stats">
                        <div className="stat">
                          <span className="stat-label">Responden</span>
                          <span className="stat-value">
                            👥 {h.jumlah_responden}
                          </span>
                        </div>
                      </div>

                      <div className="card-aspek-mini">
                        {[
                          { label: "Materi", value: h.aspek_1 },
                          { label: "Metode", value: h.aspek_2 },
                          { label: "Disiplin", value: h.aspek_3 },
                          { label: "Komunikasi", value: h.aspek_4 },
                          { label: "Motivasi", value: h.aspek_5 },
                        ].map((a, i) => (
                          <div key={i} className="mini-aspek-item">
                            <span className="mini-label">{a.label}</span>
                            <div className="mini-bar">
                              <div
                                className="mini-bar-fill"
                                style={{
                                  width: `${(a.value / 5) * 100}%`,
                                  backgroundColor: getScoreColor(a.value),
                                }}
                              />
                            </div>
                            <span className="mini-value">{a.value}</span>
                          </div>
                        ))}
                      </div>

                      <div className="card-actions">
                        <button
                          className="btn-card-resume"
                          onClick={() => loadResumeGuru(h.guru_id, h.nama_guru)}
                        >
                          💬 Lihat Resume
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* Resume Modal */}
        {showResumeModal && (
          <div
            className="modal-overlay"
            onClick={() => setShowResumeModal(false)}
          >
            <div className="modal-resume" onClick={(e) => e.stopPropagation()}>
              <div className="modal-resume-header">
                <div>
                  <h2>💬 Resume & Feedback Siswa</h2>
                  <p className="modal-subtitle">
                    {selectedGuruResume.nama} - Semester {semester}
                  </p>
                </div>
                <button
                  className="modal-close"
                  onClick={() => setShowResumeModal(false)}
                >
                  ×
                </button>
              </div>

              <div className="modal-resume-content">
                {resumeList.length === 0 ? (
                  <div className="empty-resume">
                    <div className="empty-icon">📝</div>
                    <p>Belum ada resume dari siswa untuk guru ini</p>
                  </div>
                ) : (
                  <div className="resume-list">
                    <div className="resume-summary">
                      <span className="summary-badge">
                        Total {resumeList.length} feedback dari siswa
                      </span>
                    </div>

                    {resumeList.map((resume, idx) => (
                      <div key={idx} className="resume-item">
                        <div className="resume-header">
                          <div className="resume-avatar">
                            {String.fromCharCode(65 + (idx % 26))}
                          </div>
                          <div className="resume-meta">
                            <span className="resume-from">Siswa Anonim</span>
                            <span className="resume-date">
                              {new Date(resume.created_at).toLocaleDateString(
                                "id-ID",
                                {
                                  day: "numeric",
                                  month: "long",
                                  year: "numeric",
                                }
                              )}
                            </span>
                          </div>
                          <div
                            className="resume-score"
                            style={{ color: getScoreColor(resume.rata_rata) }}
                          >
                            <span className="score-big">
                              {resume.rata_rata}
                            </span>
                            <span className="score-emoji">
                              {getScoreLabel(resume.rata_rata).emoji}
                            </span>
                          </div>
                        </div>
                        <div className="resume-content">
                          <p>"{resume.komentar}"</p>
                        </div>
                        <div className="resume-aspek-breakdown">
                          <div className="breakdown-title">
                            Detail Penilaian:
                          </div>
                          <div className="breakdown-grid">
                            {[
                              { label: "Materi", value: resume.aspek_1 },
                              { label: "Metode", value: resume.aspek_2 },
                              { label: "Disiplin", value: resume.aspek_3 },
                              { label: "Komunikasi", value: resume.aspek_4 },
                              { label: "Motivasi", value: resume.aspek_5 },
                            ].map((aspek, i) => (
                              <div key={i} className="breakdown-item">
                                <span className="breakdown-label">
                                  {aspek.label}:
                                </span>
                                <span
                                  className="breakdown-value"
                                  style={{ color: getScoreColor(aspek.value) }}
                                >
                                  {aspek.value}
                                </span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* UNIT SEKOLAH - TABLE VERSION */}
        {activeTab === "unit" && isSuperAdmin && (
          <div className="section">
            <div className="section-header">
              <h2>Data Unit Sekolah</h2>
              <button className="btn-add" onClick={() => openModal("unit")}>
                + Tambah Unit
              </button>
            </div>

            <div className="admin-table-wrapper">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th style={{ width: 50 }}>#</th>
                    <th>Nama Unit</th>
                    <th>Jenjang</th>
                    <th style={{ width: 120 }}>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {unit.map((u, index) => (
                    <tr key={u.id}>
                      <td>{index + 1}</td>
                      <td>{u.nama_unit}</td>
                      <td>
                        <span className="badge">{u.jenjang}</span>
                      </td>
                      <td>
                        <div className="table-actions">
                          <button
                            className="btn-icon edit"
                            onClick={() => openModal("unit", u)}
                            title="Edit"
                          >
                            ✏️
                          </button>
                          <button
                            className="btn-icon delete"
                            onClick={() => handleDelete("unit", u.id)}
                            title="Hapus"
                          >
                            🗑️
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}

                  {unit.length === 0 && (
                    <tr>
                      <td
                        colSpan="4"
                        style={{ textAlign: "center", padding: 20 }}
                      >
                        Tidak ada data unit sekolah
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* KELAS - TABLE VERSION */}
        {activeTab === "kelas" && (
          <div className="section">
            <div className="section-header">
              <h2>Data Kelas {!isSuperAdmin && `- ${user.nama_lengkap}`}</h2>
              {!isReadOnly && (
                <button className="btn-add" onClick={() => openModal("kelas")}>
                  + Tambah Kelas
                </button>
              )}
            </div>

            <div className="admin-table-wrapper">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th style={{ width: 50 }}>#</th>
                    <th>Nama Kelas</th>
                    <th>Tingkat</th>
                    <th>Unit</th>
                    <th style={{ width: 120 }}>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {kelas.map((k, index) => (
                    <tr key={k.id}>
                      <td>{index + 1}</td>
                      <td>{k.nama_kelas}</td>
                      <td>{k.tingkat}</td>
                      <td>
                        {k.nama_unit}{" "}
                        <span className="badge" style={{ marginLeft: 6 }}>
                          {k.jenjang}
                        </span>
                      </td>
                      <td>
                        {!isReadOnly && (
                          <div className="table-actions">
                            <button
                              className="btn-icon edit"
                              onClick={() => openModal("kelas", k)}
                              title="Edit"
                            >
                              ✏️
                            </button>
                            <button
                              className="btn-icon delete"
                              onClick={() => handleDelete("kelas", k.id)}
                              title="Hapus"
                            >
                              🗑️
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}

                  {kelas.length === 0 && (
                    <tr>
                      <td
                        colSpan="5"
                        style={{ textAlign: "center", padding: 20 }}
                      >
                        Tidak ada data kelas
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* MATA PELAJARAN - TABLE VERSION */}
        {activeTab === "mapel" && (
          <div className="section">
            <div className="section-header">
              <h2>Data Mata Pelajaran</h2>

              {!isReadOnly && (isAdminSekolah || isSuperAdmin) && (
                <button className="btn-add" onClick={() => openModal("mapel")}>
                  + Tambah Mata Pelajaran
                </button>
              )}
            </div>

            <div className="admin-table-wrapper">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th style={{ width: 50 }}>#</th>
                    <th>Nama Mata Pelajaran</th>
                    <th style={{ width: 120 }}>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {mapel.map((m, index) => (
                    <tr key={m.id}>
                      <td>{index + 1}</td>
                      <td>{m.nama_mapel}</td>
                      <td>
                        {!isReadOnly && (
                          <div className="table-actions">
                            <button
                              className="btn-icon edit"
                              onClick={() => openModal("mapel", m)}
                              title="Edit"
                            >
                              ✏️
                            </button>
                            <button
                              className="btn-icon delete"
                              onClick={() => handleDelete("mapel", m.id)}
                              title="Hapus"
                            >
                              🗑️
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}

                  {mapel.length === 0 && (
                    <tr>
                      <td
                        colSpan="3"
                        style={{ textAlign: "center", padding: 20 }}
                      >
                        Tidak ada data mata pelajaran
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* GURU - TABLE VERSION (FOTO & UPLOAD TETAP) */}
        {activeTab === "guru" && (
          <div className="section">
            <div className="section-header">
              <h2>Data Guru {!isSuperAdmin && `- ${user.nama_lengkap}`}</h2>
              {!isReadOnly && (
                <button className="btn-add" onClick={() => openModal("guru")}>
                  + Tambah Guru
                </button>
              )}
            </div>

            <div className="admin-table-wrapper">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th style={{ width: 50 }}>#</th>
                    <th style={{ width: 90 }}>Foto</th>
                    <th>Nama</th>
                    <th>NIP</th>
                    <th>Username</th>
                    <th style={{ width: 220 }}>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {guru.map((g, index) => (
                    <tr key={g.id}>
                      <td>{index + 1}</td>

                      {/* FOTO */}
                      <td>
                        {g.foto_url ? (
                          <img
                            src={g.foto_url}
                            alt={g.nama_lengkap}
                            className="foto-mini"
                          />
                        ) : (
                          <div className="foto-placeholder-mini">
                            {g.nama_lengkap.charAt(0)}
                          </div>
                        )}
                      </td>

                      <td>{g.nama_lengkap}</td>
                      <td>{g.nip}</td>
                      <td>{g.username || "-"}</td>

                      {/* AKSI */}
                      <td>
                        {!isReadOnly && (
                          <div className="table-actions">
                            {/* UPLOAD / GANTI FOTO */}
                            <label
                              className="btn-icon edit"
                              title="Upload / Ganti Foto"
                            >
                              📷
                              <input
                                type="file"
                                accept="image/jpeg,image/jpg,image/png"
                                onChange={(e) =>
                                  handleUploadFoto(g.id, e.target.files[0])
                                }
                                style={{ display: "none" }}
                              />
                            </label>

                            {/* HAPUS FOTO */}
                            {g.foto_url && (
                              <button
                                className="btn-icon delete"
                                title="Hapus Foto"
                                onClick={() => handleDeleteFoto(g.id)}
                              >
                                🖼️❌
                              </button>
                            )}

                            {/* EDIT DATA */}
                            <button
                              className="btn-icon edit"
                              title="Edit Guru"
                              onClick={() => openModal("guru", g)}
                            >
                              ✏️
                            </button>

                            {/* HAPUS DATA */}
                            <button
                              className="btn-icon delete"
                              title="Hapus Guru"
                              onClick={() => handleDelete("guru", g.id)}
                            >
                              🗑️
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}

                  {guru.length === 0 && (
                    <tr>
                      <td
                        colSpan="6"
                        style={{ textAlign: "center", padding: 20 }}
                      >
                        Tidak ada data guru
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* SISWA - TABLE VERSION */}
        {activeTab === "siswa" && (
          <div className="section">
            <div className="section-header">
              <h2>Data Siswa {!isSuperAdmin && `- ${user.nama_lengkap}`}</h2>
              {!isReadOnly && (
                <button className="btn-add" onClick={() => openModal("siswa")}>
                  + Tambah Siswa
                </button>
              )}
            </div>

            <div className="admin-table-wrapper">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th style={{ width: 50 }}>#</th>
                    <th>Nama</th>
                    <th>NIS</th>
                    <th>Kelas</th>
                    <th>Unit</th>
                    <th>Username</th>
                    <th style={{ width: 120 }}>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {siswa.map((s, index) => (
                    <tr key={s.id}>
                      <td>{index + 1}</td>
                      <td>{s.nama_lengkap}</td>
                      <td>{s.nis}</td>
                      <td>{s.nama_kelas}</td>
                      <td>{s.nama_unit}</td>
                      <td>{s.username || "-"}</td>
                      <td>
                        {!isReadOnly && (
                          <div className="table-actions">
                            <button
                              className="btn-icon edit"
                              title="Edit"
                              onClick={() => openModal("siswa", s)}
                            >
                              ✏️
                            </button>
                            <button
                              className="btn-icon delete"
                              title="Hapus"
                              onClick={() => handleDelete("siswa", s.id)}
                            >
                              🗑️
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}

                  {siswa.length === 0 && (
                    <tr>
                      <td
                        colSpan="7"
                        style={{ textAlign: "center", padding: 20 }}
                      >
                        Tidak ada data siswa
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* PENUGASAN - EXPANDABLE / ACCORDION */}
        {activeTab === "penugasan" && (
          <div className="section">
            <div className="section-header">
              <h2>
                Data Penugasan {!isSuperAdmin && `- ${user.nama_lengkap}`}
              </h2>
              {!isReadOnly && (
                <button
                  className="btn-add"
                  onClick={() => openModal("penugasan")}
                >
                  + Tambah Penugasan
                </button>
              )}
            </div>

            <div className="admin-table-wrapper">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th style={{ width: 50 }}>#</th>
                    <th>Guru</th>
                    <th>Mata Pelajaran</th>
                    <th>Semester</th>
                    <th style={{ width: 120 }}>Detail</th>
                  </tr>
                </thead>
                <tbody>
                  {groupedPenugasan.map((g, index) => (
                    <React.Fragment key={index}>
                      {/* HEADER ROW */}
                      <tr
                        style={{ cursor: "pointer", background: "#f9fafb" }}
                        onClick={() =>
                          setOpenGuruId(
                            openGuruId === g.guru_id ? null : g.guru_id
                          )
                        }
                      >
                        <td>{index + 1}</td>
                        <td>
                          <strong>{g.nama_guru}</strong>
                        </td>
                        <td>{g.nama_mapel}</td>
                        <td>
                          <span className="badge">{g.semester}</span>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {openGuruId === g.guru_id ? "▲" : "▼"}
                        </td>
                      </tr>

                      {/* DETAIL ROW */}
                      {openGuruId === g.guru_id && (
                        <tr>
                          <td colSpan="5" style={{ background: "#f3f4f6" }}>
                            <div style={{ padding: "10px 20px" }}>
                              <strong>Kelas yang diajar:</strong>
                              <ul style={{ marginTop: 8 }}>
                                <ul style={{ marginTop: 8 }}>
                                  {(g.detail || []).map((d) => (
                                    <li
                                      key={d.id}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "6px 0",
                                      }}
                                    >
                                      <span>
                                        📘 {d.nama_mapel} —{" "}
                                        <strong>{d.nama_kelas}</strong>
                                      </span>

                                      {!isReadOnly && (
                                        <button
                                          className="btn-icon delete"
                                          title="Hapus penugasan ini"
                                          onClick={() =>
                                            handleDelete("penugasan", d.id)
                                          }
                                        >
                                          🗑️
                                        </button>
                                      )}
                                    </li>
                                  ))}
                                </ul>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}

                  {groupedPenugasan.length === 0 && (
                    <tr>
                      <td
                        colSpan="5"
                        style={{ textAlign: "center", padding: 20 }}
                      >
                        Tidak ada data penugasan
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ============================================ */}
        {/* TAB SEMESTER MANAGEMENT */}
        {/* ============================================ */}
        {activeTab === "semester" && isSuperAdmin && (
          <div className="semester-management-section">
            <div className="semester-header">
              <h2>📅 Manajemen Semester</h2>
              <div className="semester-header-right">
                <button
                  className="btn-copy-penugasan"
                  onClick={openCopyPenugasanModal}
                >
                  📋 Copy Penugasan
                </button>
                <button
                  className="btn-add-semester"
                  onClick={() => openSemesterModal()}
                >
                  ➕ Tambah Semester
                </button>
              </div>
            </div>

            {semesterData.length === 0 ? (
              <div className="semester-empty-state">
                <div className="empty-icon">📅</div>
                <h3>Belum Ada Data Semester</h3>
                <p>Klik tombol "Tambah Semester" untuk membuat semester baru</p>
              </div>
            ) : (
              <div className="semester-table-container">
                <table className="semester-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Kode Semester</th>
                      <th>Nama Semester</th>
                      <th>Tahun Ajaran</th>
                      <th>Tanggal Mulai</th>
                      <th>Tanggal Selesai</th>
                      <th>Status</th>
                      <th>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {semesterData.map((sem, idx) => (
                      <tr
                        key={sem.id}
                        className={sem.is_aktif ? "active-semester" : ""}
                      >
                        <td>{idx + 1}</td>
                        <td>
                          <strong>{sem.kode_semester}</strong>
                        </td>
                        <td>{sem.nama_semester}</td>
                        <td>{sem.tahun_ajaran}</td>
                        <td>
                          {sem.tanggal_mulai
                            ? new Date(sem.tanggal_mulai).toLocaleDateString(
                                "id-ID"
                              )
                            : "-"}
                        </td>
                        <td>
                          {sem.tanggal_selesai
                            ? new Date(sem.tanggal_selesai).toLocaleDateString(
                                "id-ID"
                              )
                            : "-"}
                        </td>
                        <td>
                          <span
                            className={`status-badge ${
                              sem.is_aktif ? "active" : "inactive"
                            }`}
                          >
                            {sem.is_aktif ? "✅ Aktif" : "⭕ Nonaktif"}
                          </span>
                        </td>
                        <td>
                          <div className="semester-actions">
                            <button
                              className="btn-activate"
                              onClick={() => handleActivateSemester(sem)}
                              disabled={sem.is_aktif}
                            >
                              {sem.is_aktif ? "✅ Aktif" : "🔄 Aktifkan"}
                            </button>
                            <button
                              className="btn-edit-semester"
                              onClick={() => openSemesterModal(sem)}
                            >
                              ✏️ Edit
                            </button>
                            <button
                              className="btn-delete-semester"
                              onClick={() => handleDeleteSemester(sem)}
                            >
                              🗑️ Hapus
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* Modal Add/Edit Semester */}
        {showSemesterModal && (
          <div className="semester-modal-overlay" onClick={closeSemesterModal}>
            <div
              className="semester-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="semester-modal-header">
                <h3>
                  {editingSemester
                    ? "✏️ Edit Semester"
                    : "➕ Tambah Semester Baru"}
                </h3>
                <button
                  className="btn-close-modal"
                  onClick={closeSemesterModal}
                >
                  ×
                </button>
              </div>

              <form onSubmit={handleSemesterSubmit}>
                <div className="semester-modal-body">
                  <div className="semester-form-group">
                    <label>Kode Semester *</label>
                    <input
                      type="text"
                      placeholder="Contoh: 2025/2026-1"
                      value={semesterFormData.kode_semester || ""}
                      onChange={(e) =>
                        setSemesterFormData({
                          ...semesterFormData,
                          kode_semester: e.target.value,
                        })
                      }
                      required
                    />
                    <small>
                      Format: TAHUN/TAHUN-SEMESTER (1=Ganjil, 2=Genap)
                    </small>
                  </div>

                  <div className="semester-form-group">
                    <label>Nama Semester *</label>
                    <input
                      type="text"
                      placeholder="Contoh: Semester Ganjil 2025/2026"
                      value={semesterFormData.nama_semester || ""}
                      onChange={(e) =>
                        setSemesterFormData({
                          ...semesterFormData,
                          nama_semester: e.target.value,
                        })
                      }
                      required
                    />
                  </div>

                  <div className="semester-form-group">
                    <label>Tahun Ajaran *</label>
                    <input
                      type="text"
                      placeholder="Contoh: 2025/2026"
                      value={semesterFormData.tahun_ajaran || ""}
                      onChange={(e) =>
                        setSemesterFormData({
                          ...semesterFormData,
                          tahun_ajaran: e.target.value,
                        })
                      }
                      required
                    />
                  </div>

                  <div className="semester-form-group">
                    <label>Tanggal Mulai</label>
                    <input
                      type="date"
                      value={semesterFormData.tanggal_mulai || ""}
                      onChange={(e) =>
                        setSemesterFormData({
                          ...semesterFormData,
                          tanggal_mulai: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="semester-form-group">
                    <label>Tanggal Selesai</label>
                    <input
                      type="date"
                      value={semesterFormData.tanggal_selesai || ""}
                      onChange={(e) =>
                        setSemesterFormData({
                          ...semesterFormData,
                          tanggal_selesai: e.target.value,
                        })
                      }
                    />
                  </div>

                  {!editingSemester && (
                    <div className="semester-checkbox-group">
                      <input
                        type="checkbox"
                        id="is_aktif"
                        checked={semesterFormData.is_aktif || false}
                        onChange={(e) =>
                          setSemesterFormData({
                            ...semesterFormData,
                            is_aktif: e.target.checked,
                          })
                        }
                      />
                      <label htmlFor="is_aktif">
                        Set sebagai semester aktif
                      </label>
                    </div>
                  )}
                </div>

                <div className="semester-modal-footer">
                  <button
                    type="button"
                    className="btn-cancel"
                    onClick={closeSemesterModal}
                  >
                    Batal
                  </button>
                  <button type="submit" className="btn-submit-semester">
                    {editingSemester ? "💾 Update" : "➕ Tambah"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Warning Modal - Activate Semester */}
        {showActivateWarning && (
          <div
            className="semester-modal-overlay"
            onClick={() => setShowActivateWarning(false)}
          >
            <div
              className="semester-modal warning-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="semester-modal-header">
                <h3>⚠️ Konfirmasi Aktivasi Semester</h3>
                <button
                  className="btn-close-modal"
                  onClick={() => setShowActivateWarning(false)}
                >
                  ×
                </button>
              </div>

              <div className="warning-modal-body">
                <div className="warning-icon">⚠️</div>
                <h4>Yakin ingin mengaktifkan semester ini?</h4>
                <p>
                  Semester <strong>{semesterToActivate?.kode_semester}</strong>{" "}
                  akan diaktifkan dan semester lain akan otomatis dinonaktifkan.
                  <br />
                  <br />
                  Siswa akan mulai mengisi survey untuk semester yang baru
                  diaktifkan.
                </p>
              </div>

              <div className="warning-modal-footer">
                <button
                  className="btn-warning-cancel"
                  onClick={() => setShowActivateWarning(false)}
                >
                  Batal
                </button>
                <button
                  className="btn-warning-confirm"
                  onClick={confirmActivateSemester}
                >
                  ✅ Ya, Aktifkan
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Copy Penugasan */}
        {showCopyModal && (
          <div
            className="semester-modal-overlay"
            onClick={() => setShowCopyModal(false)}
          >
            <div
              className="semester-modal copy-penugasan-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="semester-modal-header">
                <h3>📋 Copy Penugasan Antar Semester</h3>
                <button
                  className="btn-close-modal"
                  onClick={() => setShowCopyModal(false)}
                >
                  ×
                </button>
              </div>

              <div className="semester-modal-body">
                <div className="copy-form-group">
                  <label>Dari Semester *</label>
                  <select
                    value={copyFromSemester}
                    onChange={(e) => setCopyFromSemester(e.target.value)}
                    required
                  >
                    <option value="">-- Pilih Semester Asal --</option>
                    {semesterData.map((sem) => (
                      <option key={sem.id} value={sem.id}>
                        {sem.kode_semester} - {sem.nama_semester}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="copy-form-group">
                  <label>Ke Semester *</label>
                  <select
                    value={copyToSemester}
                    onChange={(e) => setCopyToSemester(e.target.value)}
                    required
                  >
                    <option value="">-- Pilih Semester Tujuan --</option>
                    {semesterData.map((sem) => (
                      <option key={sem.id} value={sem.id}>
                        {sem.kode_semester} - {sem.nama_semester}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="copy-info">
                  <p>
                    ℹ️ <strong>Catatan:</strong> Semua penugasan guru dari
                    semester asal akan disalin ke semester tujuan. Jika semester
                    tujuan sudah memiliki penugasan, Anda akan diminta
                    konfirmasi untuk menimpa data.
                  </p>
                </div>
              </div>

              <div className="semester-modal-footer">
                <button
                  className="btn-cancel"
                  onClick={() => setShowCopyModal(false)}
                >
                  Batal
                </button>
                <button
                  className="btn-submit-semester"
                  onClick={handleCopyPenugasan}
                  style={{ background: "#f59e0b" }}
                >
                  📋 Copy Sekarang
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* MODAL FORM */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>
                {editMode ? "Edit" : "Tambah"}{" "}
                {modalType === "unit"
                  ? "Unit Sekolah"
                  : modalType === "kelas"
                  ? "Kelas"
                  : modalType === "mapel"
                  ? "Mata Pelajaran"
                  : modalType === "guru"
                  ? "Guru"
                  : modalType === "siswa"
                  ? "Siswa"
                  : "Penugasan"}
              </h2>
              <button className="close-btn" onClick={closeModal}>
                ×
              </button>
            </div>

            <form onSubmit={handleSubmit} className="modal-form">
              {/* FORM UNIT SEKOLAH */}
              {modalType === "unit" && (
                <>
                  <div className="form-group">
                    <label>Nama Unit Sekolah *</label>
                    <input
                      type="text"
                      value={formData.nama_unit || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, nama_unit: e.target.value })
                      }
                      placeholder="Contoh: SMP Pembda Nias 1"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Jenjang *</label>
                    <select
                      value={formData.jenjang || "SMP"}
                      onChange={(e) =>
                        setFormData({ ...formData, jenjang: e.target.value })
                      }
                      required
                    >
                      <option value="SD">SD</option>
                      <option value="SMP">SMP</option>
                      <option value="SMA">SMA</option>
                      <option value="SMK">SMK</option>
                    </select>
                  </div>
                </>
              )}

              {/* FORM KELAS */}
              {modalType === "kelas" && (
                <>
                  {isSuperAdmin && (
                    <div className="form-group">
                      <label>Unit Sekolah *</label>
                      <select
                        value={formData.unit_sekolah_id || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            unit_sekolah_id: e.target.value,
                          })
                        }
                        required
                      >
                        <option value="">Pilih Unit Sekolah</option>
                        {unit.map((u) => (
                          <option key={u.id} value={u.id}>
                            {u.nama_unit}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {isAdminSekolah && (
                    <div className="form-group">
                      <label>Unit Sekolah</label>
                      <input type="text" value={user.nama_lengkap} disabled />
                    </div>
                  )}
                  <div className="form-group">
                    <label>Nama Kelas *</label>
                    <input
                      type="text"
                      value={formData.nama_kelas || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, nama_kelas: e.target.value })
                      }
                      placeholder="Contoh: 7A, 10 IPA 1"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Tingkat *</label>
                    <input
                      type="number"
                      value={formData.tingkat || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, tingkat: e.target.value })
                      }
                      placeholder="Contoh: 7, 10, 12"
                      required
                    />
                  </div>
                </>
              )}

              {/* FORM MATA PELAJARAN */}
              {modalType === "mapel" && (
                <div className="form-group">
                  <label>Nama Mata Pelajaran *</label>
                  <input
                    type="text"
                    value={formData.nama_mapel || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, nama_mapel: e.target.value })
                    }
                    placeholder="Contoh: Matematika"
                    required
                  />
                </div>
              )}

              {/* FORM GURU */}
              {modalType === "guru" && (
                <>
                  <div className="form-group">
                    <label>NIP *</label>
                    <input
                      type="text"
                      value={formData.nip || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, nip: e.target.value })
                      }
                      placeholder="Contoh: 198501012010011001"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Nama Lengkap *</label>
                    <input
                      type="text"
                      value={formData.nama_lengkap || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          nama_lengkap: e.target.value,
                        })
                      }
                      placeholder="Contoh: Budi Santoso, S.Pd"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Username (untuk login)</label>
                    <input
                      type="text"
                      value={formData.username || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, username: e.target.value })
                      }
                      placeholder="Kosongkan jika tidak membuat akun"
                    />
                  </div>
                  <div className="form-group">
                    <label>Password</label>
                    <input
                      type="password"
                      value={formData.password || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, password: e.target.value })
                      }
                      placeholder={
                        editMode
                          ? "Kosongkan jika tidak diubah"
                          : "Kosongkan jika tidak membuat akun"
                      }
                    />
                  </div>
                </>
              )}

              {/* FORM SISWA */}
              {modalType === "siswa" && (
                <>
                  <div className="form-group">
                    <label>NIS *</label>
                    <input
                      type="text"
                      value={formData.nis || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, nis: e.target.value })
                      }
                      placeholder="Contoh: 2024001"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Nama Lengkap *</label>
                    <input
                      type="text"
                      value={formData.nama_lengkap || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          nama_lengkap: e.target.value,
                        })
                      }
                      placeholder="Contoh: Ahmad Rizki"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Kelas *</label>
                    <select
                      value={formData.kelas_id || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, kelas_id: e.target.value })
                      }
                      required
                    >
                      <option value="">Pilih Kelas</option>
                      {kelas.map((k) => (
                        <option key={k.id} value={k.id}>
                          {k.nama_kelas} - {k.nama_unit}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Username (untuk login)</label>
                    <input
                      type="text"
                      value={formData.username || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, username: e.target.value })
                      }
                      placeholder="Kosongkan jika tidak membuat akun"
                    />
                  </div>
                  <div className="form-group">
                    <label>Password</label>
                    <input
                      type="password"
                      value={formData.password || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, password: e.target.value })
                      }
                      placeholder={
                        editMode
                          ? "Kosongkan jika tidak diubah"
                          : "Kosongkan jika tidak membuat akun"
                      }
                    />
                  </div>
                </>
              )}

              {/* FORM PENUGASAN */}
              {modalType === "penugasan" && (
                <>
                  <div className="form-group">
                    <label>Guru *</label>
                    <select
                      value={formData.guru_id || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, guru_id: e.target.value })
                      }
                      required
                    >
                      <option value="">Pilih Guru</option>
                      {guru.map((g) => (
                        <option key={g.id} value={g.id}>
                          {g.nama_lengkap} ({g.nip})
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Kelas *</label>
                    <select
                      value={formData.kelas_id || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, kelas_id: e.target.value })
                      }
                      required
                    >
                      <option value="">Pilih Kelas</option>
                      {kelas.map((k) => (
                        <option key={k.id} value={k.id}>
                          {k.nama_kelas} - {k.nama_unit}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Mata Pelajaran *</label>
                    <select
                      value={formData.mata_pelajaran_id || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          mata_pelajaran_id: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="">Pilih Mata Pelajaran</option>
                      {mapel.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.nama_mapel}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Semester *</label>
                    <select
                      value={formData.semester || semester}
                      onChange={(e) =>
                        setFormData({ ...formData, semester: e.target.value })
                      }
                      required
                    >
                      <option value="">Pilih Semester</option>
                      {semesterList.map((s) => (
                        <option key={s.id} value={s.kode_semester}>
                          {s.kode_semester} {s.is_active === 1 ? "(Aktif)" : ""}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}

              <div className="modal-actions">
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={closeModal}
                >
                  Batal
                </button>
                <button type="submit" className="btn-submit">
                  {editMode ? "Update" : "Simpan"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminPage;
